import axios from 'axios';
import { keyAccessToken, keyUserId } from '../../../../assets/js/SessionStorageNames';


const SendData = (entId, hash) => {
    const resp = axios.post(`${process.env.REACT_APP_BACKEND_URL}/v1/clean-img/send-has-base64`, {
        hasBase64: hash,
        enterpriseId: entId,
    }, {
        headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
        },
    })
    return resp
}

export default SendData